export const formatInstrumentLabel = (symbol: string): string => {
  if (symbol.length !== 6) return symbol
  return `${symbol.slice(0, 3)}/${symbol.slice(3)}`
}
